import script from "./ResepResep.vue?vue&type=script&setup=true&lang=js"
export * from "./ResepResep.vue?vue&type=script&setup=true&lang=js"

import "./ResepResep.vue?vue&type=style&index=0&id=5b912eac&scoped=true&lang=css"

import exportComponent from "D:\\mahfud\\git\\melinda\\ft\\foodtrav\\foodtraveller\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b912eac"]])

export default __exports__